export default function ProductForm({
  data,
  setData,
  errors = [],
  processing = false,
  onSubmit,
  submitLabel,
  layout = "page"
}) {
  const isDrawerLayout = layout === "drawer";

  return (
    <div className={isDrawerLayout ? "workspace-content workspace-content--drawer" : "workspace-content"}>
      <div className={isDrawerLayout ? "" : "container-fluid px-0"}>
        <div className="row">
          <div className="col-12">
            <div className={`card ${isDrawerLayout ? "workspace-drawer-form-card" : ""}`.trim()}>
              <div className="card-body">
                {errors.length > 0 && (
                  <div className="alert alert-danger">
                    {errors.join(", ")}
                  </div>
                )}

                <form className="vstack gap-4" onSubmit={onSubmit}>
                  <div>
                    <label className="form-label fw-semibold" htmlFor="product-name">
                      Navn
                    </label>
                    <input
                      id="product-name"
                      className="form-control"
                      value={data.product.name}
                      onChange={(e) => setData("product", { ...data.product, name: e.target.value })}
                      required
                    />
                  </div>

                  <div>
                    <label className="form-label fw-semibold" htmlFor="product-description">
                      Beskrivelse
                    </label>
                    <textarea
                      id="product-description"
                      className="form-control"
                      rows="8"
                      value={data.product.description}
                      onChange={(e) => setData("product", { ...data.product, description: e.target.value })}
                    />
                  </div>

                  <div className="col-md-4 px-0">
                    <label className="form-label fw-semibold" htmlFor="product-index">
                      Rækkefølge
                    </label>
                    <input
                      id="product-index"
                      className="form-control"
                      type="number"
                      min="0"
                      value={data.product.index}
                      onChange={(e) => setData("product", { ...data.product, index: e.target.value })}
                      required
                    />
                  </div>

                  <div className="d-flex justify-content-end">
                    <button className="btn btn-primary px-4" disabled={processing}>
                      {submitLabel}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
